const workspace = require("./images/workspace.jpeg");
const joinspace = require("./images/joinspace.jpeg");

export { workspace, joinspace };
